import { all, put, takeEvery, select } from 'redux-saga/effects'
import { AnyAction } from 'redux'
import actions from './actions'
import { TDefaultSagas } from '../interface'

export function* ADD_ITEM({ payload }: AnyAction) {
  const { key, value } = payload

  try {
    const breadcrumb = yield select((state: TDefaultSagas) => state.breadcrumb)

    if (!breadcrumb.map.has(key)) {
      breadcrumb.map.set(key, value)
    }

    yield put({
      type: actions.SET_STATE,
      payload: { map: breadcrumb.map },
    })
  } catch (error) {
    console.log(error)
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.ADD_ITEM, ADD_ITEM)])
}
